import React, { useContext, useEffect } from "react";
import { CommonContext } from "hooks/CommonContext";
import { FaStopCircle } from "react-icons/fa";
import screen_record from "assets/screen_record.svg";

const RecordingButton = () => {
  const { socketRef, isRecording, stopRecording, startRecording } =
    useContext(CommonContext);

  useEffect(() => {
    return () => {
      socketRef.current.off("chunk_received");
      // eslint-disable-next-line
      socketRef.current.off("recording_saved");
    };
    // eslint-disable-next-line
  }, []);

  return (
    <button
      title={isRecording ? "Stop recording" : "Start recording"}
      className={`ftr-btn${isRecording ? " ftr-rec" : ""}`}
      onClick={() => {
        if (isRecording) stopRecording();
        else startRecording();
      }}
    >
      {isRecording ? (
        <>
          <FaStopCircle />
          <span className="ftr-rec-dot" />
        </>
      ) : (
        <img src={screen_record} alt="Start recording" />
      )}
    </button>
  );
};

export default RecordingButton;